module Meevo.Components.LocationPicker {
  "use strict";

  export interface ILocationPickerContext {
    selectedStateChanged(): void;
    reset(): void;
    search(): void;
    changeLocation(location: any): void;
    home(): void;
    searchResults: any;
    cityCriteria: any;
  }

  export class LocationPickerContext implements ILocationPickerContext {
    private itemsPerPage: any = 20;
    searchResults: any;
    searchCriteria: any = {};
    cityCriteria: any = {};
    selectedState: any = undefined;
    selectedCity: any = undefined;
    selectedService: any = undefined;

    constructor(private $window: angular.IWindowService,
        private appSettings: Meevo.Components.Common.IAppSettings,
        private identityService: Meevo.Components.Common.IIdentityService,
        private dataService: Meevo.Components.BaseClasses.IDataService,
        private changeLocationOverride: Function = null,
        private enableUserFilter: boolean = true,
        private excludeCurrentLocation: boolean = false,
        private isChangeLocation:boolean=false,
        private excludeCallCenter: boolean = false,
        private busyService: Meevo.Components.Busy.IBusyService,
        private locationPickerService: ILocationPickerService) {

      this.loadFromLocalStorage();
    }
      public functionIsRunning = false;

    selectedStateChanged(): void {
      this.selectedCity = undefined;
      this.cityCriteria = this.selectedState ? { state: this.selectedState.state } : {};
    }

    reset(): void {
      this.searchCriteria = {};
      this.cityCriteria = {};
      this.selectedState = undefined;
      this.selectedCity = undefined;
      this.selectedService = undefined;

      sessionStorage.removeItem(Components.Common.Constants.SS_LOCATION_OVERRIDE);
      sessionStorage.removeItem(Components.Common.Constants.SS_LOCATION_SEARCH_CRITERIA);
    }

    search(): void {
        var uri = this.isChangeLocation ? "changelocation" : "location";
      this.searchResults = new Meevo.Components.BaseClasses.PagedResults(this.dataService, uri);

      this.searchCriteria.city = this.selectedCity ? this.selectedCity.city : undefined;
      this.searchCriteria.state = this.selectedState ? this.selectedState.state : undefined;
      this.searchCriteria.serviceId = this.selectedService ? this.selectedService.id : undefined;
      this.searchCriteria.filterBySessionUser = this.enableUserFilter;
      this.searchCriteria.locationStatus = [Meevo.Model.LocationStatusEnum.Active, Meevo.Model.LocationStatusEnum.ClosingPlanned, Meevo.Model.LocationStatusEnum.TemporarilyClosed];
      this.searchCriteria.subscriptionStatus = [Meevo.Model.SubscriptionStatusEnum.Active];

      if (this.excludeCurrentLocation) {
        this.searchCriteria.excludeIdList = [this.identityService.locationId];
      }

      if (this.excludeCallCenter){
        const existingList = Model.Guard.isNothing(this.searchCriteria.excludeIdList) ? new Array<number>() : this.searchCriteria.excludeIdList as Array<number>;
        this.searchCriteria.excludeIdList = [ ...existingList, this.identityService.current().callCenterId, this.identityService.current().centralOfficeId ];
      }

      // Prepare request
      let request = {
        pageNumber: 1,
        itemsPerPage: this.itemsPerPage,
        criteria: this.searchCriteria,
        sortBy: '',
        sortDirection: Model.SortDirection.Ascending,
        includeActive: true,
        includeDeleted: false,
        includeInactive: false
      };

      // Execute request into ties
      this.searchResults.initSearch(request);
      this.saveToLocalStorage();
    }

      changeLocation(location: any): void {
        if (_.isFunction(this.changeLocationOverride)) {
            this.changeLocationOverride({ location: location });
        }
        else {
            this.locationPickerService.switchLocation(location.id);
          }          
    }

    home():void {
      sessionStorage.removeItem(Components.Common.Constants.SS_LOCATION_OVERRIDE);
      this.locationPickerService.switchLocation(this.identityService.current().homeLocationId);
    }

    private loadFromLocalStorage() {
      if (sessionStorage.getItem(Components.Common.Constants.SS_LOCATION_SEARCH_CRITERIA)) {
        var storageItem = JSON.parse(sessionStorage.getItem(Components.Common.Constants.SS_LOCATION_SEARCH_CRITERIA));
        this.selectedCity = storageItem.selectedCity;
        this.selectedState = storageItem.selectedState;
        this.selectedService = storageItem.selectedService;
        this.searchCriteria.zipCode = storageItem.zipCode;
        this.searchCriteria.storeNumber = storageItem.storeNumber;
        }
    }

    private saveToLocalStorage() {
      var storageItem = {
        selectedCity: this.selectedCity,
        selectedState: this.selectedState,
        selectedService: this.selectedService,
        zipCode: this.searchCriteria.zipCode,
        storeNumber: this.searchCriteria.storeNumber
      }
      sessionStorage.setItem(Components.Common.Constants.SS_LOCATION_SEARCH_CRITERIA,
        JSON.stringify(storageItem));
    }
  }
}